const RightArrow = ({ width }) => {
    return (
        <div className={`right-arrow ${width}`}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 107 67">
                <g fill="#414042">
                    <path d="M99.695 30.045H.525v7.09h99.17z"></path>
                    <path
                        d="M68.676 61.758L96.86 33.59 68.676 5.422 73.694.408l33.199 33.182-33.2 33.182z"
                    ></path>
                </g>
            </svg>
        </div>
    )
}

export default RightArrow
